import type { EntityGraphNode } from "../engine/EntityGraphNode/EntityGraphNode.type"
import type { BuildingEntity } from "./EntityType/Building"
import type { FactoryEntity } from "./EntityType/Factory"
import type { HQEntity } from "./EntityType/HQ"
import { EntityTypeId, HasEntityTypeId } from "./EntityTypeId.enum"
import type { Entity } from "./index"

export type MapControlTargetEntity = HQEntity | BuildingEntity | FactoryEntity

const mapControlTargetEntityTypeIdList = [
  EntityTypeId.HQ,
  EntityTypeId.Building,
  EntityTypeId.Factory,
]

function isEntityUnit<T extends EntityGraphNode>(
  entity: T
): entity is T & EntityGraphNode<MapControlTargetEntity>

function isEntityUnit(
  entity: Entity
): entity is MapControlTargetEntity

function isEntityUnit<T extends HasEntityTypeId> (
  entity: T
): entity is T & {etype_id: MapControlTargetEntity['etype_id']} {
  return mapControlTargetEntityTypeIdList.includes(entity.etype_id)
}

export default isEntityUnit
